/**
 * Per-channel messaging windows — how long after the customer's last message the
 * platform still accepts an outbound. Mirrors `channel-text-limits.ts`: isomorphic
 * (type-only import, no server deps) so the settings UI can warn about the same
 * bound the adapters enforce, without pulling the adapter registry into the client.
 *
 * Must agree with each adapter's `getCapabilities().messagingWindowHours`.
 * Total `Record<ChannelType, ...>` on purpose: a new channel fails typecheck here.
 */

import type { ChannelType } from '../types'

/** `null` = no platform window; the agent's session bound still applies. */
export const CHANNEL_MESSAGING_WINDOW_HOURS: Record<ChannelType, number | null> = {
  instagram: 24,
  facebook: 24,
  whatsapp: 24,
  tiktok: 48,
  telegram: null,
  web_widget: null,
  web_demo: null,
}
